function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.572 17.484l-8.98 9.52C8.66 27.99 7 27.331 7 25.973V6.037c0-1.39 1.728-2.032 2.636-.98l8.98 10.418a1.5 1.5 0 01-.044 2.01z",
    fill: props.color || 'black',
    stroke: props.color || 'black'
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color || 'black',
    strokeWidth: 4,
    strokeLinecap: "round",
    d: "M24 6v20"
  }));
}
export default SvgNext;